import { buildFlightFlowDashboardPath } from "../../flightBookingPathUtils";

/**
 * Footer «חזור» target. Must not send flightDetails back to the search
 * landing — that drops `/flights/results` and remounts an empty page.
 */

export function isSelfComposeFlightOffer(offer) {
  return !!(
    offer &&
    (offer.isSelfComposeCombined || offer.source === "selfCompose")
  );
}

/**
 * @param {string} currentStep
 * @param {object | null | undefined} selectedFlightOffer
 * @param {{ needsSelfComposePickStep?: boolean, allowSelfComposeChoice?: boolean }} [searchGate]
 * @returns {string | null} booking step id, or null to exit to product categories
 */
export function resolveFlightWizardBackStep(
  currentStep,
  selectedFlightOffer,
  searchGate = {}
) {
  if (currentStep === "passengers") return "flightDetails";
  if (currentStep === "extras") return "passengers";
  if (currentStep === "review") return "extras";
  if (currentStep === "draftPayment") return "review";
  if (currentStep === "flightDetails") {
    const fromSelfCompose = isSelfComposeFlightOffer(selectedFlightOffer);
    const selfComposeStillInFlow =
      !!searchGate.needsSelfComposePickStep ||
      !!searchGate.allowSelfComposeChoice;
    if (fromSelfCompose && selfComposeStillInFlow) {
      return "selfComposePick";
    }
    return "results";
  }
  if (currentStep === "selfComposePick") {
    return "results";
  }
  if (currentStep === "holdConfirmation") {
    return "review";
  }
  return null;
}

/**
 * Apply resolveFlightWizardBackStep: goToStep + same dashboard path builder
 * the wizard footer uses. Returns the step id, or null when the footer
 * should exit to categories instead.
 */
export function applyResolvedFlightWizardBack({
  currentStep,
  selectedFlightOffer,
  searchGate,
  goToStep,
  navigate,
  pathname,
  routeParams,
  setFlightSearchEditorOpen,
} = {}) {
  const backStep = resolveFlightWizardBackStep(
    currentStep,
    selectedFlightOffer,
    searchGate || {}
  );
  if (!backStep) return null;
  if (typeof setFlightSearchEditorOpen === "function") {
    setFlightSearchEditorOpen(false);
  }
  if (typeof goToStep === "function") goToStep(backStep);
  const targetPath = buildFlightFlowDashboardPath(routeParams, backStep);
  if (typeof navigate === "function" && pathname !== targetPath) {
    navigate(targetPath);
  }
  return backStep;
}
